<!-- Modal Overlay -->
<div
  *ngIf="isVisible"
  class="fixed inset-0 z-50 overflow-y-auto"
  (keydown)="onKeydown($event)"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'confirmation-modal-title'"
  [attr.aria-describedby]="'confirmation-modal-description'"
>
  <!-- Background Overlay -->
  <div
    class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-300 ease-out"
    (click)="onOverlayClick($event)"
    aria-hidden="true"
  ></div>

  <!-- Modal Container -->
  <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
    
    <!-- Modal Panel -->
    <div
      class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all duration-300 ease-out sm:my-8 sm:w-full sm:max-w-lg scale-95 opacity-0 animate-slide-in"
    >
      <!-- Modal Content -->
      <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
        <div class="sm:flex sm:items-start">
          
          <!-- Icon Container -->
          <div 
            *ngIf="config.showIcon"
            class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:mx-0 sm:h-10 sm:w-10"
            [ngClass]="{
              'bg-red-100': config.type === 'danger',
              'bg-yellow-100': config.type === 'warning', 
              'bg-blue-100': config.type === 'info',
              'bg-green-100': config.type === 'success',
              'bg-gray-100': config.type === 'info' || !config.type
            }"
          >
            <i
              [class]="'fas ' + getIcon()"
              [ngClass]="{
                'text-red-600': config.type === 'danger',
                'text-yellow-600': config.type === 'warning',
                'text-blue-600': config.type === 'info', 
                'text-green-600': config.type === 'success',
                'text-gray-600': config.type === 'info' || !config.type
              }"
              aria-hidden="true"
            ></i>
          </div>

          <!-- Content -->
          <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left" [ngClass]="{'w-full': !config.showIcon}">
            
            <!-- Title -->
            <h3 
              class="text-base font-semibold leading-6 text-gray-900" 
              id="confirmation-modal-title"
            >
              {{ config.title }}
            </h3>
            
            <!-- Message -->
            <div class="mt-2" id="confirmation-modal-description">
              <p class="text-sm text-gray-500 leading-relaxed">
                {{ config.message }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
        
        <!-- Confirm Button -->
        <button
          type="button"
          [class]="getConfirmButtonClasses()"
          (click)="onConfirm()"
          #confirmButton
        >
          {{ config.confirmText }}
        </button>

        <!-- Cancel Button -->
        <button
          *ngIf="config.showCancel !== false"
          type="button"
          class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto transition-colors duration-200"
          (click)="onCancel()"
        >
          {{ config.cancelText }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Accessibility: Focus trap elements -->
<div *ngIf="isVisible" tabindex="0" (focus)="confirmButton.nativeElement.focus()"></div>
